import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/grid.svg';

import styles from './GridIcon.styles';

type GridIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'GridIcon' });

export default function GridIconIcon({ className }: GridIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
